module.exports = __webpack_public_path__ + "static/img/bg-01.de3cf7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-01.jpg
// module id = j1BE
// module chunks = 100